import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  ImportPurchaseCheckbox: {
    Max_SKU_Count: false,
    Group_Retail_Sales: false,
    Group_Retail_Stock: false,
    Group_Consm: false,
    Pending_Qty: false,
    Lead_Days_Sales: false,
    Excess_Short_During_LD: false,
    Exess_Qty_During_LD: false,
    Req_Qty_Forecast_Days: false,
    Req_Qty: true,
    Final_Qty: true,
  },
};

const SliceIMPurchaseRequest = createSlice({
  name: "SliceIMPurchaseRequest",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_IMPurchaseRequest_Init: (state) => {
      state.value = initialState;
    },

    //RESET CHECKBOX
    Set_WmsInnModelCheckbox_Init: (state) => {
      state.value.ImportPurchaseCheckbox = {
        Max_SKU_Count: false,
        Group_Retail_Sales: false,
        Group_Retail_Stock: false,
        Group_Consm: false,
        Pending_Qty: false,
        Lead_Days_Sales: false,
        Excess_Short_During_LD: false,
        Exess_Qty_During_LD: false,
        Req_Qty_Forecast_Days: false,
        Req_Qty: true,
        Final_Qty: true,
      };
    },

    Set_WmsInnModelCheckbox: (state, action) => {
      state.value.ImportPurchaseCheckbox = action.payload;
    },
  },
});

export const {
  Set_IMPurchaseRequest_Init,
  Set_WmsInnModelCheckbox,
  Set_WmsInnModelCheckbox_Init,
} = SliceIMPurchaseRequest.actions;
export default SliceIMPurchaseRequest.reducer;
